import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { Nullable } from 'primereact/ts-helpers';

interface IndividualStudentReport {
  dates: Nullable<Date[]>;
  isLoadingPdf: boolean;
}

export interface IndividualStudentReportState {
  value: { dates: Nullable<number[]>; isLoadingPdf: boolean };
}

const today = Date.now();
const initialState: IndividualStudentReportState = { value: { dates: [today, today], isLoadingPdf: false } };

const serializeDates = (dates: Nullable<Date[]>): Nullable<number[]> => {
  if (dates == null) return dates;
  return dates.map(date => date.getTime());
};

const deserializeDates = (dates: Nullable<number[]>): Nullable<Date[]> => {
  if (dates == null) return dates;
  return dates.map(timestamp => new Date(timestamp));
};

export const accessTokenSlice = createSlice({
  name: 'IndividualReport',
  initialState,
  reducers: {
    setIndividualStudentReport: {
      reducer: (state: IndividualStudentReportState, action: PayloadAction<IndividualStudentReportState['value']>) => {
        state.value = action.payload;
      },
      prepare: (report: IndividualStudentReport) => ({
        payload: {
          ...report,
          dates: serializeDates(report.dates),
        },
      }),
    },
  },
});

export const selectedIndividualStudentReportState = createSelector(
  [(state: RootState) => state.individualStudentReport.value],
  report => ({
    ...report,
    dates: deserializeDates(report.dates),
  }),
);

export const { setIndividualStudentReport } = accessTokenSlice.actions;

export default accessTokenSlice.reducer;
